import { compose, path } from "ramda";
import { createSelector } from "reselect";

export const scopeSelector = state => state.modules.calling;

export const createTokenApi = compose(
  path(["api", "createToken"]),
  scopeSelector
);

export const isNotCallTime = createSelector(
  [createTokenApi],
  api => api.error && api.error.message === "It's not time for the call"
);



// WEBPACK FOOTER //
// ./src/modules/calling/selectors.js